export default class FirmwareUpdateError extends Error {
    constructor(errorType) {
        super();
        this.errorType = errorType;
    }
}
